import { configureStore } from "@reduxjs/toolkit";
import BasicSlice from "./basic/basic.slice";
import CompanyInfoSlice from "./companyInfo/companyInfo.slice";
import ArticleCategory from "./articleCategory/articleCategory.slice";
import BanersSlice from "./baners/baners.slice";
import SlidersSlice from "./sliders/sliders.slice";
import UserSlice from "./user/user.slice";
import BlogsSlice from "./blogs/blogs.slice";
import PartnersSlice from "./partners/partners.slice";
import AuthSlice from "./authentication/authentication.slice";
import ArticlesSlice from "./articles/articles.slice";
import ArticleDetailSlice from "./articleDetail/articleDetail.slice";
import CartSlice from "./cart/cart.slice";
import OrderSlice from "./order/order.slice";
import SearchSlice from "./search/search.slice";
import ThemeReducer from "./themeSlice";
import AssetsSlice from "./assets/assets.slice";
import CatalogSlice from "./catalog/catalog.slice";
import OurProjectsSlice from "./ourProjects/ourProjects.slice";
import UserArticle from "./userArticle/userArticle.slice";

export const store = configureStore({
  reducer: {
    basic: BasicSlice,
    companyInfo: CompanyInfoSlice,
    articleCategory: ArticleCategory,
    baners: BanersSlice,
    sliders: SlidersSlice,
    user: UserSlice,
    userArticle: UserArticle,
    blogs: BlogsSlice,
    partners: PartnersSlice,
    auth: AuthSlice,
    articles: ArticlesSlice,
    articleDetail: ArticleDetailSlice,
    cart: CartSlice,
    order: OrderSlice,
    search: SearchSlice,
    theme: ThemeReducer,
    assets: AssetsSlice,
    catalog: CatalogSlice,
    ourProjects: OurProjectsSlice,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export type ErrorResponse = {
  msg: string;
};
